import { InstallPwaButton } from "@features/pwa";
import { trackAnalytics } from "@shared/libs";
import { Modal, type ModalProps } from "@shared/ui/Modal";
import { Stack } from "@shared/ui/Stack";
import { clsx } from "clsx";
import { FC } from "react";
import RocketIcon from '@shared/assets/rocket_icon.svg';
import CloseGrayIcon from '@shared/assets/close_gray.svg';
import styles from './InstallPwaModalStyle.module.css';

export const InstallPwaModal: FC<ModalProps> = (props) => {
  const { contentClassName, onClose, ...modalProps } = props;

  const modalContentClassNames = clsx(styles.modal_content_container, contentClassName);

  const handleInstallReject = () => {
    localStorage.setItem("is-pwa-installed", "false");
  };

  const handleInstallFinish = () => {
    localStorage.setItem("is-pwa-installed", "true");
    onClose();
  };

  const handleCloseModal = () => {
    handleInstallReject();
    trackAnalytics('pwa_install_modal_closed');
    onClose();
  };

  return (
    <Modal contentClassName={modalContentClassNames} onClose={handleCloseModal} {...modalProps}>
      <>
        <button className={styles.close_button_icon} onClick={handleCloseModal}>
          <img src={CloseGrayIcon} alt="close modal" />
        </button>
        <Stack gap={24} alignItems="center" justifyContent="center">
          <Stack justifyContent="center" alignItems="center" className={styles.icon_container}>
            <img src={RocketIcon} alt="rocket" />
          </Stack>
          <Stack gap={10} alignItems="center" justifyContent="center" fullWidth>
            <h3 className={styles.title_text}>
              Get our app!
            </h3>
            <p className={styles.description_text}>
              Install it on your device for a faster and more convenient experience
            </p>
          </Stack>
          <InstallPwaButton
            className={styles.install_pwa_btn}
            onReject={handleInstallReject}
            onFinish={handleInstallFinish}
          >
            Install
          </InstallPwaButton>
        </Stack>
      </>
    </Modal>
  );
};